var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03955 10.2104C5.77637 10.2104 5.55615 10.1138 5.33594 9.89355L1.36133 5.82764C1.2002 5.66113 1.11963 5.46777 1.11963 5.23682C1.11963 4.75879 1.50098 4.37207 1.97363 4.37207C2.20996 4.37207 2.43018 4.46875 2.60742 4.646L6.04492 8.19092L9.47705 4.646C9.6543 4.46875 9.87451 4.37207 10.1055 4.37207C10.5781 4.37207 10.9595 4.75879 10.9595 5.23682C10.9595 5.47314 10.8789 5.6665 10.7178 5.82764L6.74316 9.89355C6.53369 10.1084 6.30811 10.2104 6.03955 10.2104Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.d9fa782f41a5bd366f574b91ac1464bc.svg";
export { ForwardRef as ReactComponent };